import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import {
  beneLookUp,
  resetInEdit,
  resetVerification,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import CommonToast from "../../../../components/_utils/CommonToast";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import {
  getSpecificFieldForceAccount,
  filedForceApproval,
  filedForceDeniedAccount,
} from "../../../../redux/features/accounts/fieldForceAccount";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import ICONS from "../../../../assets/Icons";

const FieldForcePanEditSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [rejectPopup, setRejectPopup] = useState(false);
  const [declineReason, setDeclineReason] = useState("");

  const { id } = useParams();
  const updatedFields = location?.state?.updatedFields || [];
  const [previousAssociated, setPreviousAssociated] = useState(0);
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
  });
  const services = useSelector((state) => state.refreshToken.services);
  useEffect(() => {
    dispatch(resetVerification());
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const fetchFieldForcePANSuccessDetail = async () => {
      let response = await dispatch(getSpecificFieldForceAccount({ id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchFieldForcePANSuccessDetail();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    const storedValue = localStorage.getItem("haveAssociated");
    if (storedValue !== null) {
      setPreviousAssociated(JSON.parse(storedValue));
    }
  }, []);

  const { beneLookData } = useSelector((state) => state.verify);
  const {
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
  } = useSelector((state) => state.fieldForceAccount);

  const fieldForceAccount = useMemo(
    () => getSpecificFieldForceAccountData?.field_force_accounts?.[0] || {},
    [getSpecificFieldForceAccountData],
  );

  useEffect(() => {
    if (fieldForceAccount && Object.keys(fieldForceAccount).length > 0) {
      const { id, name, bank_name, bank_acc_no, ifsc_code, category, pan_no } =
        fieldForceAccount;
      setCurrentAccountDetails({
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
      });
    }
  }, [fieldForceAccount]);

  const createTxn = () => {
    navigate(
      `/field_force_transaction_dashboard/create_field_force_transaction`,
    );
  };
  const createAccount = () => {
    navigate("/field_force_account_dashboard/create_field_force_account", {
      state: currentAccountDetails,
    });
  };
  const viewDetailsHandler = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };
  const dashboardHandler = () => {
    navigate("/field_force_account_dashboard");
  };

  let haveApproved = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "approved";
  });
  let havePending = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "pending" && val?.id !== id;
  });
  const AccountIdData = declineReason;
  const accountApproval = () => {
    (async () => {
      toast.dismiss();
      CommonToast({
        text: "Field force account getting approved",
        variant: "var(--processing)",
        icon: ICONS?.LOADER_GIF,
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      let response = await dispatch(filedForceApproval(id));
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Field force account approved",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });

        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.field_force_account[
            GlobalConfiguration.lengthCheckZero
          ],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }
    })();
  };

  const accountRejected = () => {
    (async () => {
      toast.dismiss();
      CommonToast({
        text: "Field force account getting rejected",
        variant: "var(--processing)",
        icon: ICONS?.LOADER_GIF,
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      let response = await dispatch(
        filedForceDeniedAccount({ id, AccountIdData }),
      );
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Field force account rejected",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });

        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.field_force_account[
            GlobalConfiguration.lengthCheckZero
          ],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
        setRejectPopup(false);
      }
    })();
  };
  useEffect(() => {
    if (
      !getSpecificFieldForceAccountLoading &&
      getSpecificFieldForceAccountData
    ) {
      dispatch(
        beneLookUp({
          pan_number:
            getSpecificFieldForceAccountData?.field_force_accounts?.[0]?.pan_no,
        }),
      );
    }
    return () => {
      dispatch(resetInEdit());
    };
  }, [
    dispatch,
    getSpecificFieldForceAccountLoading,
    getSpecificFieldForceAccountData,
  ]);
  const buttonRows = [
    ...(services?.includes("FFAAccount") ||
    (services?.includes("Admin") &&
      fieldForceAccount?.approval_status === "pending")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              handleFunction: () => {
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              handleFunction: () => {
                accountApproval();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
          ],
        ]
      : []),
    [
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const handleInputChange = (event) => {
    const sanitizedValue = event.target.value
      .replace(/\s+/g, " ")
      .replace(/^\s/, "")
      .slice(0, 150);

    setDeclineReason(sanitizedValue);
  };
  const shouldShowAssociatedTab =
    previousAssociated === false &&
    (haveApproved !== undefined || havePending !== undefined);

  const approvedAccounts =
    beneLookData?.beneficiary_accounts?.filter(
      (val) => val?.approval_status === "approved",
    ) || [];

  const pendingAccounts =
    beneLookData?.beneficiary_accounts?.filter(
      (val) => val?.approval_status === "pending" && val?.id !== id,
    ) || [];

  const fieldsToShow =
    updatedFields.length > GlobalConfiguration.lengthCheckZero
      ? updatedFields
      : ["pan_no", "gstin_detail"];

  const panGstFieldConfig = {
    pan_no: {
      leftSubTitle: "PAN number",
      getTitle: (acc) => acc?.pan_no,
    },
    gstin_detail: {
      leftSubTitle: "GST number (optional)",
      getTitle: (acc) => acc?.gstin_detail,
    },
  };

  const getPanGstSuccessTitle = () => {
    return "Account details updated successfully.";
  };

  const renderPanGstCards = () => {
    return fieldsToShow
      .filter((key) => panGstFieldConfig[key])
      .filter(
        (key) => key !== "gstin_detail" || fieldForceAccount?.gstin_detail,
      )
      .map((key) => {
        const config = panGstFieldConfig[key];
        const title = config.getTitle(fieldForceAccount);
        if (key === "gstin_detail" && !title) return null;
        return (
          <InfoCard
            key={key}
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: title || "Not Given",
                leftSubTitle: config.leftSubTitle,
              },
            ]}
          />
        );
      });
  };

  return (
    <>
      {rejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            subtext="Please state the reason for rejecting the account"
            headerFontColor="text-primary"
            headerFontWeight="semibold"
            textSize="font-md"
            inputPlaceholder="Reason(10-150 char)"
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              handleInputChange(e);
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneHandleFunction={() => {
              setRejectPopup(false);
              setDeclineReason("");
            }}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="trans"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              accountRejected();
              setDeclineReason("");
            }}
            btnTwoBtnType="submit"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      <StatusContainer
        isLoading={getSpecificFieldForceAccountLoading}
        status="success"
        hoverOption="white"
        title={getPanGstSuccessTitle()}
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="Updated details">
          <>{renderPanGstCards()}</>
        </TabsWeapperSection>
        {shouldShowAssociatedTab && (
          <TabsWeapperSection title="Accounts Associated to PAN">
            <>
              {haveApproved && approvedAccounts.length > 0 && (
                <>
                  {approvedAccounts.map((val, index) => (
                    <InfoCard
                      key={val?.id || index}
                      bgColor="var(--positive-card)"
                      header={true}
                      borderColor="var(--positive-bg)"
                      rightHeaderText="Approved account"
                      rightHeaderTextColor="var(--text-secondary)"
                      leftHeaderText={val?.name}
                      rows={[
                        {
                          leftTitle: formatAccountNumber(val?.bank_acc_no),
                          leftSubTitle: "Bank account number",
                          ifsc: val?.ifsc_code,
                        },
                      ]}
                    />
                  ))}
                </>
              )}
              {havePending && pendingAccounts.length > 0 && (
                <>
                  {pendingAccounts.map((val, index) => (
                    <InfoCard
                      key={val?.id || index}
                      bgColor="var(--positive-card)"
                      header={true}
                      borderColor="var(--positive-bg)"
                      rightHeaderText="Pending account"
                      rightHeaderTextColor="var(--text-secondary)"
                      leftHeaderText={val?.name?.toLowerCase()}
                      rows={[
                        {
                          leftTitle: formatAccountNumber(val?.bank_acc_no),
                          leftSubTitle: "Bank account number",
                          ifsc: val?.ifsc_code,
                        },
                      ]}
                    />
                  ))}
                </>
              )}
              {!haveApproved &&
                !havePending &&
                (!beneLookData?.beneficiary_accounts ||
                  beneLookData.beneficiary_accounts.length === 0) && (
                  <InfoCard
                    bgColor="var(--positive-card)"
                    rows={[
                      {
                        leftTitle:
                          "  No associated accounts found for the PAN details provided",
                        leftSubTitle:
                          " There are no existing accounts that are associated with the PAN details provided.",
                      },
                    ]}
                  />
                )}
            </>
          </TabsWeapperSection>
        )}
      </StatusContainer>
    </>
  );
};

export default FieldForcePanEditSuccess;
